import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthProvider';
import Layout from './masterdata/Layout';

const ProtectedRoute = ({ requiredRole = null }) => {
  const { isAuthenticated, hasRole, loading } = useAuth();

  // Show loading while checking authentication
  if (loading) {
    return <div>Loading...</div>;
  }

  // Check if user is authenticated
  if (!isAuthenticated()) {
    console.log('User not authenticated, redirecting to login');
    return <Navigate to="/masterdata" replace />;
  }
  
  // Check role if required (optional - for future use)
  if (requiredRole && !hasRole(requiredRole)) {
    console.log(`User doesn't have required role: ${requiredRole}, redirecting to login`);
    return <Navigate to="/masterdata" replace />;
  }
  
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default ProtectedRoute;